import LeistungsseiteTemplate from "@/components/feature/LeistungsseiteTemplate";
import { allTestimonials } from "@/data/testimonials";
import g2Hero from "@/assets/g2-hero.png";
import g2HeroMain from "@/assets/g2-hero-main.png";
import g2Tarife from "@/assets/g2-tarife.png";
import g2Ems from "@/assets/g2-ems.png";
import g2Partner from "@/assets/g2-partner.png";
import g2ContractingAnwendung from "@/assets/g2-contracting-anwendung.png";
import Seo, { serviceSchema } from "@/components/feature/Seo";
export default function G2Contracting() {
  return (
    <>
      <Seo
        title="G2 Contracting | Zweering Elektrotechnik Emmerich am Rhein"
        description="G2 Contracting: intelligente Energieversorgung und Mieterstrom-Konzepte für Immobilien in Emmerich am Rhein und Umgebung."
        canonical="https://zweering.de/g2-contracting"
        breadcrumbs={[{"name": "Startseite", "url": "https://zweering.de/"}, {"name": "G2 Contracting", "url": "https://zweering.de/g2-contracting"}]}
      />
      <LeistungsseiteTemplate
      theme="futuristic"
      label="DIE INTELLIGENTE SCHICHT"
      title="G2 CONTRACTING"
      subline="Zweering baut Ihr Energiesystem. G2 Contracting macht es klug. Energiemanagement und dynamische Tarife — die Software über Ihrer Hardware."
      heroImage={g2HeroMain}
      heroImageAlt="Wallbox lädt E-Auto vor Wohnhaus mit visualisierten Energieflüssen — G2 Contracting"
      leadText={
        <>
          Eine Solaranlage erzeugt Strom. Ein Speicher hält ihn. Aber wann laden, wann
          einspeisen, wann aus dem Netz ziehen — das entscheidet die{" "}
          <span style={{ color: "#4CAF50" }}>Intelligenz dahinter</span>. Das ist G2
          Contracting.
        </>
      }
      stats={[
        { value: "Über 400", label: "PV-Anlagen installiert" },
        { value: "5,0 ★", label: "Google-Bewertung" },
        { value: "Niederrhein", label: "Hier sind wir zuhause" },
      ]}

      panels={[
        {
          title: "VON HARDWARE ZU SYSTEM",
          body: "Zweering installiert Photovoltaik, Speicher und Wallbox. G2 Contracting verbindet diese Bausteine zu einem Energiesystem, das aktiv mitdenkt.",
          image: g2Hero,
          imageAlt: "Wechselrichter und Batteriespeicher — Hardware-Basis für G2 Contracting",
        },
        {
          title: (
            <>
              <span style={{ color: "#4CAF50" }}>DYNAMISCHE TARIFE</span> NUTZEN
            </>
          ),
          body: "Strompreise schwanken stündlich. G2 lädt Ihren Speicher, wenn Strom günstig ist, und nutzt ihn, wenn er teuer ist — automatisch.",
          image: g2Tarife,
          imageAlt: "Smartphone mit dynamischem Strompreis-Chart — G2 Contracting Tarifsteuerung",
        },
        {
          title: "ENERGIE-MANAGEMENT, DAS ARBEITET",
          body: "Wärmepumpe, Wallbox, Speicher — alle Verbraucher werden so gesteuert, dass Sie maximal von Ihrem eigenen Strom und günstigen Zeiten profitieren.",
          image: g2Ems,
          imageAlt: "Wallbox, Wärmepumpe und Smart-Home-Steuerung — vernetztes Energiemanagement",
        },
        {
          title: "EIN PARTNER, ZWEI EBENEN",
          body: "Zweering und G2 Contracting greifen ineinander: das Handwerk, das baut, und die Software, die optimiert — aus einer Hand gedacht.",
          image: g2Partner,
          imageAlt: "Handschlag auf dem Dach vor PV-Anlage — Zweering und G2 Contracting als Partner",
        },
      ]}
      showTrustStar={false}
      trustLine="G2 Contracting — Energiemanagement als Software-Ebene."
      testimonials={allTestimonials}
      manifest={"Ihr Energiesystem.\nGebaut von Zweering.\nOptimiert von G2."}
      caseStudy={{
        label: "ANWENDUNG",
        title: "ENERGIE-MANAGEMENT IN DER PRAXIS",
        text: "Ein bestehendes PV-Speicher-System mit dynamischem Tarif verbunden — der Speicher lädt automatisch in günstigen Stunden.",
        linkLabel: "Mehr erfahren",
        href: "https://g2-contracting.de",
        image: g2ContractingAnwendung,
        imageAlt: "Gewerbegebäude mit großer Photovoltaikanlage auf dem Flachdach — Energiemanagement in der Praxis",
      }}
      faq={[
        {
          frage: "Was genau ist G2 Contracting?",
          antwort:
            "G2 Contracting ist die intelligente Energiemanagement-Schicht über Ihrer Anlage: dynamische Tarife, automatische Steuerung Ihrer Verbraucher, Optimierung von Eigenverbrauch und Kosten.",
        },
        {
          frage: "Brauche ich dafür eine Zweering-Anlage?",
          antwort:
            "G2 setzt auf vorhandener Hardware auf. Zweering baut diese Hardware — beides greift nahtlos ineinander, kommt aber auch einzeln in Frage.",
        },
        {
          frage: "Ist G2 etwas anderes als Zweering?",
          antwort:
            "G2 Contracting ist die Software-Ebene, Zweering das Elektro-Handwerk — zwei Ebenen, ein Weg zu Ihrem optimierten Energiesystem.",
        },
        {
          frage: "Was kostet G2 Contracting?",
          antwort:
            "Es gibt keine Pauschalantwort: Die Kosten hängen von Ihrer bestehenden Hardware, dem gewählten Tarifmodell und Ihrem Verbrauch ab. In einem kurzen Gespräch rechnen wir Ihr individuelles Rendite-Potenzial transparent durch.",
        },
        {
          frage: "Was passiert, wenn G2 ausfällt — leuchtet bei mir trotzdem das Licht?",
          antwort:
            "Ja. G2 ist eine Optimierungs-Schicht, kein Schalter zwischen Ihnen und dem Netz. Fällt die Steuerung aus, läuft Ihre Anlage im Standardbetrieb weiter — Strom, Speicher und Verbraucher arbeiten wie gewohnt.",
        },
        {
          frage: "Wer haftet für die Steuerung meiner Anlage?",
          antwort:
            "Für die Software-Ebene und deren Steuerlogik haftet G2 Contracting. Für die installierte Hardware (PV, Speicher, Wallbox) bleibt der jeweilige Installateur — bei uns also Zweering — verantwortlich. Beides ist vertraglich klar getrennt.",
        },
      ]}
      ctaText={{
        headline: "BEREIT FÜR DIE INTELLIGENTE EBENE?",
        subtext: "Kostenlos, unverbindlich, in 2 Minuten.",
        buttonLabel: "Rendite-Potenzial berechnen →",
        buttonHref: "https://g2-contracting.de",
        buttonExternal: true,
        secondaryButtonLabel: "G2 kennenlernen →",
        secondaryButtonHref: "https://g2-contracting.de",
        secondaryButtonExternal: true,
        variant: "dark",
      }}

      crossLink={{
        label: "WEITERLESEN",
        title: "MEHR AUF G2-CONTRACTING.DE",
        text: "Vertiefen Sie das Thema Energiemanagement auf der eigenen G2-Seite.",
        href: "https://g2-contracting.de",
        image: "",
        imageAlt: "G2 Contracting",
        titleSize: "clamp(1.25rem, 4.5vw, 2.5rem)",
      }}
    />
    </>
  );
}
